<template>
    <div class="safeCenter">
        <Header title="安全中心" :show-back="true"/>
        <div class="content">
            <van-cell
                    is-link
                    title="交易密码"
                    class="cell"
                    to="/dealpwd"/>
            <van-cell
                    is-link
                    title="登录密码"
                    class="cell"
                    to="/dealLoginPwd"/>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";

    export default {
        components: {
            Header
        },
        data() {
            return {};
        }
    }
</script>

<style lang="scss">
    .safeCenter {
        min-height: 100vh;

        .content {
            padding: 30px;
        }

        .cell {
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.4);
            border-radius: 20px;
            padding: 30px 30px;
            margin-bottom: 27px;

            &-title {
                color: #3E3E3E;
                font-size: 30px;

            }
        }
    }

</style>
